import * as React from "react";
const ToggleOffSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 2", fill: "currentColor", width: size || "8", height: size || "2", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0H8V2H0z" }));
ToggleOffSmall.displayName = "ToggleOffSmall";
var ToggleOffSmall_default = ToggleOffSmall;
export {
  ToggleOffSmall_default as default
};
